import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'
import { images } from '../../../assets'
import { RatingStar } from '../../common'
import { dateFormat } from '../../tools'

/** 이미지 슬라이드 팝업 */
const InterestImgPopup = ({ interestInfo, appImg, handleImgPopupBtn }) => {
  const [activeSlide, setActiveSlide] = useState(0) // slide pagination

  const settings = {
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    beforeChange: (current, next) => {
      setActiveSlide(next)
    },
  } //슬라이드 설정

  return (
    <div className="InterestPopup InterestImgPopup SubPages">
      <div className="interest_review_popup_wrap">
        <div className="interest_popup_header">
          <div className="review_user">
            <div className="user_img">{appImg(interestInfo.app_type_code)}</div>
            <div className="user_name">
              <p className="name bold">{interestInfo.member_nickname}님</p>
              <div className="user_rate">
                <RatingStar rank={interestInfo.rating} />
                <div className="user_review_date">{dateFormat(interestInfo.review_reg_dt)}</div>
              </div>
            </div>
          </div>
          <div className="close_btn" onClick={handleImgPopupBtn}></div>
        </div>
        <div className="img_content">
          <Slider {...settings} className="popupSlide">
            {interestInfo.image_list.map((item, i) => (
              <img className="review_img" src={item.image_url} alt={item.src} key={i} />
            ))}
          </Slider>
        </div>
        <div className="slide_pagination">
          <span className="bold">{activeSlide + 1}</span> / {interestInfo.image_list.length}
        </div>
      </div>
    </div>
  )
}

/** 리뷰 가이드 팝업 */
const InterestGuidePopup = ({ handleGuidePopupBtn }) => {
  return (
    <div className="InterestPopup InterestGuidePopup SubPages">
      <div className="interest_review_popup_wrap">
        <div className="interest_popup_header">
          <div className="close_btn" onClick={handleGuidePopupBtn}></div>
          <div className="title">
            스폰지R <br />
            관심리뷰 가이드
          </div>
        </div>
        <div className="guide_contents">
          <div className="interest_review_guide">
            <div>
              <div className="title">사장님 댓글</div>
              <img src={images.review_guide_img01} alt="사장님 댓글" />
              <div className="bold">&#91;등록하기&#93;</div>
              <ul>
                <li>사장님 댓글을 수정 후 등록하실 수 있습니다.</li>
                <li>금일 17시까지 등록하지 않으시면 자동으로 추천 댓글이 등록됩니다.</li>
              </ul>
            </div>

            <div>
              <img src={images.review_guide_img02} alt="댓글 등록 거부" />
              <div className="bold">&#91;댓글 등록 거부&#93;</div>
              <ul>
                <li>게시를 중단 하거나 채널에서 댓글을 등록할 리뷰인 경우 선택하세요. </li>
                <li>스폰지R의 댓글 관리 서비스에서 제외됩니다.</li>
              </ul>
            </div>
          </div>
          <div className="app_review_guide">
            <div>
              <div className="title">채널 별 리뷰 게시중단 방법</div>
              <div className="app_name">
                <img src={images.review_img02} alt="배달의 민족" />
                <div className="bold">배달의 민족</div>
              </div>
              <div className="app_cs">
                <div className="txt">고객센터 전화번호</div>
                <div>1600-0987</div>
                <div className="txt">고객센터 이메일</div>
                <div>cs@woowahan.com</div>
              </div>
              <ul>
                <li>1. 고객센터에 게시중단 신청서를 요청합니다.</li>
                <li>2. 게시중단 신청서를 작성합니다.</li>
                <li>3. 게시중단 신청서와 신분증&#40;주민등록번호 뒷부분 마스킹 필요&#41;을 이메일로 발송합니다.</li>
              </ul>
            </div>

            <div>
              <div className="app_name">
                <img src={images.review_img03} alt="쿠팡" />
                <div className="bold">쿠팡</div>
              </div>
              <div className="app_cs">
                <div className="txt">고객센터 전화번호</div>
                <div>1600-9827</div>
                <div className="txt">고객센터 이메일</div>
                <div>eatspartners@coupang.com</div>
              </div>
              <ul>
                <li>1. 고객센터에 게시중단 신청서를 요청합니다. </li>
                <li>2. 게시중단 신청서를 작성합니다.</li>
                <li>3. 게시중단 신청서와 신분증&#40;주민등록번호 뒷부분 마스킹 필요&#41;을 이메일로 발송합니다.</li>
                <li>
                  4. 이메일 제목과 내용은 아래의 형식으로 기재해주세요.
                  <ul>
                    <li>메일 제목&#58; &#91;게시 중단 요청하기&#93; </li>
                    <li>메일 내용&#58; 매장명, 접수일자</li>
                  </ul>
                </li>
              </ul>
            </div>

            <div>
              <div className="app_name">
                <img src={images.review_img01} alt="요기요" />
                <div className="bold">요기요</div>
              </div>
              <ul>
                <li>1. 카카오톡 ‘요기요 사장님' 채널을 검색합니다.</li>
                <li>2. 채널 하단의 ‘챗봇 채팅' 연결을 선택합니다. </li>
                <li>3. ‘그 외 문의하기 &#62; 리뷰 관련’을 선택합니다.</li>
                <li>4. 하단의 ‘임시 노출 중단 요청'을 선택합니다. </li>
                <li>5. 본인 인증 후 노출 중단 요청 과정을 완료합니다.</li>
              </ul>
            </div>
          </div>
        </div>
        <button className="btn btn_close bold" type="button" onClick={handleGuidePopupBtn}>
          확인
        </button>
      </div>
    </div>
  )
}

export { InterestImgPopup, InterestGuidePopup }
